import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';

const WatchModalUser = ({ item, show, setShow, size }) => {
  const { t } = useTranslation(['backoffice']);

  const handleClose = () => {
    setShow(false)
  }

  return (
    <>
      <ModalCustom show={show} onHide={handleClose} size={size || "md"}>
        <div className="watchlist-image-box">
          {typeof item === 'string' && item !== '' ? (
            <img className="w-100 h-auto" src={item} alt="Item" />
          ) : item && item?.image ? (
            <img className="w-100 h-auto" src={item.image} alt="Item" />
          ) : (
            <p>{t('noimage')}</p>
          )}
        </div>
      </ModalCustom>
    </>
  );
};

WatchModalUser.propTypes = {
  item: PropTypes.string | PropTypes.object,
  show: PropTypes.bool,
  setShow: PropTypes.func,
  size: PropTypes.string
};

export default WatchModalUser;
